import React, { useEffect, useState } from 'react';
import APIService, { IActiveCountry, IPrediction } from 'services/APIService';
import { getErrorMessage } from 'utils/generalUtils';
import { keyBy } from 'lodash/fp';
import rootState from 'RootStore';
import PredictionDisplay from './PredictionDisplay';
import { C_DETAIL_VIEW_WAIT_FOR_ID_TIMEOUT_MS } from '../../../constants';

type Props = {
    id?: string;
};

const PredictionDisplayProvider = React.memo(({ id }: Props) => {
    const [isLoadingPrediction, setIsLoadingPrediction] = useState(true);
    const [predictionData, setPredictionData] = useState<IPrediction>(null);
    const [error, setError] = useState<string>(null);
    const countriesById: { [countryID: number]: IActiveCountry } = keyBy(
        (country: IActiveCountry) => country.id,
        rootState.countryStore.countries.licensedCountriesArr
    );
    useEffect(() => {
        if (id) return void loadPrediction(id);
        const timer = setTimeout(() => {
            setIsLoadingPrediction(false);
            setError('No prediction to display');
        }, C_DETAIL_VIEW_WAIT_FOR_ID_TIMEOUT_MS);
        return () => clearTimeout(timer);
    }, [id]);
    const loadPrediction = async (id: string) => {
        setIsLoadingPrediction(true);
        setError(null);
        try {
            const prediction = await APIService.getFullPrediction(id);
            setPredictionData(prediction);
        } catch (err) {
            console.log('load prediction error', err);
            setError(getErrorMessage(err, 'Failed to load prediction'));
        } finally {
            setIsLoadingPrediction(false);
        }
    };

    return (
        <PredictionDisplay
            prediction={predictionData}
            isLoading={isLoadingPrediction}
            error={error}
            countriesById={countriesById}
        />
    );
});

export default PredictionDisplayProvider;
